import { IztContent } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    tree: []
  },
  actions: {
    async fetchTree({ commit }, params) {
      try {
        const res = await IztContent.getTree(params)
        const data = Array.isArray(res) ? res : res.data || []
        commit('setTree', data)
        return data
      } catch (err) {
        console.error(err)
        return []
      }
    }
  },
  mutations: {
    setTree(state, payload) {
      state.tree = payload
    }
  }
}
